import { render } from "./RuiNavigation.vue?vue&type=template&id=7beafc51&scoped=true"
import script from "./RuiNavigation.vue?vue&type=script&lang=ts"
export * from "./RuiNavigation.vue?vue&type=script&lang=ts"

import "./RuiNavigation.vue?vue&type=style&index=0&id=7beafc51&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7beafc51"

export default script